// eslint-disable-next-line @typescript-eslint/triple-slash-reference, spaced-comment
/// <reference types="@ps/web-spade-sdk/types" />
import { Sites } from '@ps/platform-message-framework/common/Sites';
import type { InitSchema } from '@ps/web-spade-sdk/schema';
import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { select } from '../../';

export const useSpadeSdk = () => {
  const locale = useSelector(select.locale.get);
  const siteId = useSelector(select.cms.getSiteId);

  const spadeSdk = useRef(
    window.Spade?.init({
      locale: locale as InitSchema['locale'],
      brand: siteId === Sites.IT_SISAL_EXT ? 'sisal' : 'pokerstars',
      // TODO: WP-7786 Make dynamic
      site: 'it'
    })
  );

  return spadeSdk.current;
};
